import React, { useState } from "react";
import { Card, Form, Row, Col, Button, Table } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const BASE_URL = "https://sutmmg.codydeasoftech.in/";

const AccountStatement = () => {
  const [vendorType, setVendorType] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [vendorList, setVendorList] = useState([]);
  const [loadingVendor, setLoadingVendor] = useState(false);

  /* ================= FETCH VENDORS BY TYPE ================= */
  const fetchVendorsByType = async (type) => {
    let url = "";

    if (type === "CLF") url = `${BASE_URL}api/clf`;
    else if (type === "ALF") url = `${BASE_URL}api/alfs`;
    else if (type === "SHG") url = `${BASE_URL}api/shg`;
    else return;

    try {
      setLoadingVendor(true);
  const token = localStorage.getItem("token");

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setVendorList(res.data?.data || []);
    } catch (error) {
      console.error(`${type} fetch error`, error);
      Swal.fire("Alert", `Failed to load ${type} list`, "error");
      setVendorList([]);
    } finally {
      setLoadingVendor(false);
    }
  };

  /* ================= HANDLERS ================= */
  const handleVendorTypeChange = (e) => {
    const type = e.target.value;

    setVendorType(type);
    setVendorId("");
    setVendorList([]);

    if (type) fetchVendorsByType(type);
  };

  const handleReset = () => {
    setVendorType("");
    setVendorId("");
    setVendorList([]);
  };

  const tHeadStyle ={

                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",

  }

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* ================= FILTER CARD ================= */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-filter me-2"></i> Account Statement
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            {/* VENDOR TYPE */}
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Organisation Type</Form.Label>
                <Form.Select value={vendorType} onChange={handleVendorTypeChange}  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}>
                  <option value="">Select Type</option>
                  <option value="CLF">CLF</option>
                  <option value="ALF">ALF</option>
                  <option value="SHG">SHG</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* VENDOR NAME */}
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Organisation Name</Form.Label>
                <Form.Select
                  value={vendorId}
                  disabled={!vendorType || loadingVendor}
                  onChange={(e) => setVendorId(e.target.value)}

                   style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">
                    {loadingVendor ? "Loading..." : "Select Organisation"}
                  </option>

                  {vendorList.map((v) => (
                    <option key={v.id} value={v.id}>
                      {v.name || v.shg_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* BUTTONS */}
            <Col md={4} className="d-flex gap-3 mt-3">
                          <Button
                            className="w-50 fw-semibold text-white"
                            style={{ background: "#1565C1", borderRadius: "10px" }}

                          >
                            <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                          </Button>

                          <Button
                            className="w-50 fw-semibold text-white"
                            style={{ background: "#E53935", borderRadius: "10px" }}

                          >
                            <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
                          </Button>
                        </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ================= TABLE (STATIC FOR NOW) ================= */}
      <Card className="border-0">
        <Table bordered hover responsive striped>
          <thead>
            <tr className="text-center">
              <th style={tHeadStyle}>SL</th>
              <th style={tHeadStyle}>Date</th>
              <th style={tHeadStyle}>Job Category</th>
              <th style={tHeadStyle}>Debit</th>
              <th style={tHeadStyle}>Credit</th>
              <th style={tHeadStyle}>Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <td>1</td>
              <td>10-01-2026</td>
              <td>Stitching</td>
              <td>-</td>
              <td>5,000</td>
              <td>5,000</td>
            </tr>
          </tbody>
        </Table>
      </Card>
    </div>
  );
};

export default AccountStatement;
